module.exports = __webpack_public_path__ + "static/img/java2.90073646.png";